import {
  ModalBody,
  ModalFooter,
  Text,
  UseDisclosureProps,
} from "@chakra-ui/react";
import PrimaryButton from "components/PrimaryButton";
import { RequestModal } from "components/RequestModals";

const InvalidQuantityRequestedAlert = ({
  onClose = () => {
    return;
  },
  isOpen,
  quantityOverContract,
}: {
  quantityOverContract: number;
} & UseDisclosureProps) => (
  <RequestModal
    isOpen={isOpen as boolean}
    onClose={onClose}
    header="Invalid Quantity Requested"
  >
    <ModalBody>
      <Text>
        The quantity of your request exceeds the permitted amount by{" "}
        {quantityOverContract} tons. Please adjust the quantity/number of orders
        and try again
      </Text>
    </ModalBody>
    <ModalFooter>
      <PrimaryButton onClick={onClose}>Ok</PrimaryButton>
    </ModalFooter>
  </RequestModal>
);

export default InvalidQuantityRequestedAlert;
